import { RedoCarrierName } from "@redotech/redo-fulfillment-rate-common/carrier-account";

export function getFilteredCarrierOptions({
  carrierOptions,
  checkoutOptimizationEnabled = false,
  newOmsEnabled = false,
  returnsEnabled = false,
  sendcloudByoaEnabled = false,
}: {
  carrierOptions: RedoCarrierName[];
  checkoutOptimizationEnabled?: boolean;
  newOmsEnabled?: boolean;
  returnsEnabled?: boolean;
  sendcloudByoaEnabled?: boolean;
}): RedoCarrierName[] {
  const shippingEnabled = newOmsEnabled || checkoutOptimizationEnabled;
  const filtered = carrierOptions.filter((carrier) => {
    switch (carrier) {
      case RedoCarrierName.UPS_MAIL_INNOVATIONS:
        return false;
      case RedoCarrierName.CANADA_POST:
        return returnsEnabled;
      case RedoCarrierName.CANADA_POST_DIRECT:
      case RedoCarrierName.USPS_DIRECT:
        return shippingEnabled;
      case RedoCarrierName.USPS:
      case RedoCarrierName.USPS_SHIP:
        return !shippingEnabled;
      default:
        return true;
    }
  });

  // Sendcloud BYOA is gated per team (default OFF) — hide it as an addable
  // carrier until the team is enabled in LaunchDarkly.
  const filteredForSendcloud = sendcloudByoaEnabled
    ? filtered
    : filtered.filter((carrier) => carrier !== RedoCarrierName.SENDCLOUD);

  return filteredForSendcloud.sort((a, b) => a.localeCompare(b));
}
